<div class="form-flow-view">
  <div class="step-list">
    <mat-nav-list>
      @for (step of steps; track stepsTrackBy($index, step)) {
        <mat-list-item id="{{step.StepId}}" routerLinkActive="active" [queryParams]="{stepId: step.StepId, drivingField: null, getMultiFields: false}" [routerLink]="['step']" queryParamsHandling="merge">
          <span style="font-size: 14px">{{step.StepName | translate: 'Text' | async}}</span>&nbsp;&nbsp;&nbsp;
          <span style="font-size: x-small">{{step.IsMultiStep ? 'Multi' : step.IsTemplateStep ? 'Template' : ''}}</span>
        </mat-list-item>
      }
    </mat-nav-list>
  </div>
  <div class="step-item-view">
    @if (!stepItemView.isActivated) {
      <div style="margin-left: 20px;">
        <h1>Choose a step</h1>
      </div>
    }
    <router-outlet #stepItemView="outlet"></router-outlet>
  </div>
</div>


